'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('@emotion/react');
var InternalButton_web = require('../../internal/InternalButton/InternalButton.web.cjs');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('react');
require('@remix-run/react');
require('react-router-dom');
require('../../../../../../_virtual/index.cjs');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../Typography/Typography.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');
var Tooltip_web = require('../Tooltip/Tooltip.web.cjs');

/**
 * A styled component used as a trigger to perform a specific action. Communicates what action will occur when the button is clicked.
 *
 * {@link https://aviary.fullscript.io/latest/components/button/web-vZ196Hl1 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Button/Button.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Button = ({ disabled, disabledTooltipContent, ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: disabledTooltipContent ?? "",
        alignment: "top",
        isTooltipHidden: !disabled || !disabledTooltipContent,
        children: /*#__PURE__*/ jsxRuntime.jsx(InternalButton_web.InternalButton, {
            "data-testid": "aviary-button",
            disabled: disabled,
            ...rest
        })
    });
};

exports.Button = Button;
//# sourceMappingURL=Button.web.cjs.map
